const TimeUnitType = Object.freeze({
  MILLISECOND: "ms",
  SECOND: "s",
  MINUTE: "min",
  HOUR: "h"
});
export default TimeUnitType;